import { render, staticRenderFns } from "./InsectPest.vue?vue&type=template&id=59c46887&scoped=true&"
import script from "./InsectPest.vue?vue&type=script&lang=ts&"
export * from "./InsectPest.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c46887",
  null
  
)

export default component.exports